export function MaterialAllowZeroCostField(props: {
  checked: boolean;
  onChange: (allowed: boolean) => void;
  disabled?: boolean;
}) {
  return (
    <label className="flex items-start gap-2 text-xs text-gray-700 dark:text-zinc-200">
      <input
        type="checkbox"
        className="mt-0.5 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
        checked={props.checked}
        disabled={props.disabled}
        onChange={(e) => props.onChange(e.target.checked)}
      />
      <span>
        Intentionally $0
        <span className="mt-1 block text-[11px] text-gray-500 dark:text-zinc-400">
          Cutoffs and other materials we use for free. A $0 cost will not show up as a missing price.
        </span>
      </span>
    </label>
  );
}
